import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取发票抬头列表（根据分公司）
export function getInvoiceTitlesByOffice(params) {
  return request({
    url: URL.sys.getInvoiceTitlesByOffice,
    method: 'get',
    params
  })
}

// 获取发票抬头列表（根据分公司）包含开票员信息
export function queryInvoiceTitleByOfficeFunc(data) {
  return request({
    url: URL.sys.queryInvoiceTitleByOfficeUrl,
    method: 'post',
    data
  })
}

// 保存发票抬头
export function saveInvoiceTitle(data) {
  return request({
    url: URL.sys.saveInvoiceTitle,
    method: 'post',
    data
  })
}
